// @flow
import React from "react"
import GooglePlacesAutoComplete from "react-places-autocomplete"
import { GooglePlacesAutoCompleteWrapper, PlaceAutocomplete, PlacesList } from "./styled"

type Props = {
    handleSelect?: Function,
    handleChange: Function,
    value: string,
    placeholder: string,
    debounce: number,
    types: string[],
}

const PlaceSearch = ({handleSelect, handleChange, value, placeholder, debounce, types}:Props) => (
     <GooglePlacesAutoComplete
        onSelect={handleSelect}
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
        debounce={debounce}
        searchOptions={{
          types,
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <GooglePlacesAutoCompleteWrapper>
            <PlaceAutocomplete
              {...getInputProps({
                placeholder: placeholder,
                className: "location-search-input",
              })}
            />
            {suggestions.length > 0 &&
              <PlacesList className="autocomplete-dropdown-container">
                {loading && <div>Loading...</div>}
                {suggestions.map(suggestion => {
                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item"
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: "#fafafa", cursor: "pointer" }
                    : { backgroundColor: "#ffffff", cursor: "pointer" }
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                      key={suggestion.placeId}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </PlacesList>
            }
          </GooglePlacesAutoCompleteWrapper>
        )}
      </GooglePlacesAutoComplete>
)

export default PlaceSearch



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/AffiliateSelector/PlaceSearch/index.js